import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import VisibilitySensor from 'react-visibility-sensor';
import {
  CamGroupCarouselView,
  VideoPlayer,
  CommentsView,
  InfoPanelView,
  NewsletterView,
} from '../../components';
import { panelWidgets } from '../../constants/widgets';
import DisqusView from '../../components/Comments/Disqus';
import MultiBoards from '../../components/Comments/MultiBoards';

// const LAZY_LOAD_TOP_OFFSET = 200;

const CommentsComponent = ({
  newCommentSystem,
  ...rest
}) => newCommentSystem ? (<CommentsView {...rest} />) : (<DisqusView {...rest} />);

CommentsComponent.propTypes = {
  newCommentSystem: PropTypes.bool.isRequired,
};

class LiveCam extends React.Component {
  shouldRenderPanel(type) {
    if (type === 'weather' && !this.props.weatherEnabled) {
      return false;
    }
    return true;
  }

  render() {
    const { commentsFullWidth, newCommentSystem, isMultiLivecam } = this.props;
    const containerClass = isMultiLivecam ? 'container-fluid' : 'container-fluid content';
    const rightColClass = commentsFullWidth || isMultiLivecam ? 'col-12' : 'col-12 col-md-6';
    const showInfoPanel = !commentsFullWidth && !isMultiLivecam;
    const showNewsletter = !commentsFullWidth && !isMultiLivecam;

    return (
      <div className="livecams transition-item">
        <CamGroupCarouselView />
        <div className={containerClass}>
          <div className="row">
            <div className="col-sm-12">
              <VideoPlayer />
            </div>
          </div>

          <div className="row info-panels">
            {showInfoPanel &&
              <div className="col-12 col-md-6 pr-10" id="left-column">
                <div className="dynamic-height-column">
                  {panelWidgets.map((type) => {
                    return this.shouldRenderPanel(type) ? <InfoPanelView type={type} key={type} /> : null;
                  })}
                </div>
              </div>
            }

            <div className={`${rightColClass} mb-2`} id="right-column">
              <div id="disqus-drag" className="disqus-comments bg-fff-75 container-rounded">
                <VisibilitySensor partialVisibility>
                  {({ isVisible }) => (
                    isMultiLivecam ? (
                      <MultiBoards isVisible={isVisible} />
                    ) : (
                      <CommentsComponent
                        newCommentSystem={newCommentSystem}
                        isVisible={isVisible}
                      />
                    )
                  )}
                </VisibilitySensor>
              </div>
            </div>
          </div>
        </div>

        {showNewsletter &&
          <div className="container-boxShadow mt-20 rounded-0 bg-fff-50">
            <NewsletterView />
          </div>
        }

        <div className="container-fluid content my-20">
          <div className="bg-fff-50 video-player container-rounded">
            {/* <LazyLoad offset={LAZY_LOAD_TOP_OFFSET}>
              <PostersGrid />
            </LazyLoad> */}
          </div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  let backgroundImage = (!state.currentItem.data.is_offline && state.currentItem.data.snapshot)
    ? state.currentItem.data.snapshot : state.currentItem.data.thumbnail_large_url;

  backgroundImage = backgroundImage.replace('http://files', 'https://files');

  const { commentsFullWidth } = state.uiPreferences;
  /* global SERVER_URL */
  const devEnv = SERVER_URL.includes('dev');

  return {
    backgroundImage,
    commentsFullWidth,
    weatherEnabled: state.currentItem.data.weather_enabled,
    newCommentSystem: (devEnv) ? true : state.currentItem.data.newCommentSystem,
    isMultiLivecam: state.currentItem.data.cam_group.multi_livecam,
  };
};

LiveCam.propTypes = {
  weatherEnabled: PropTypes.bool.isRequired,
  commentsFullWidth: PropTypes.bool.isRequired,
  newCommentSystem: PropTypes.bool.isRequired,
  isMultiLivecam: PropTypes.bool.isRequired,
};

LiveCam.defaultProps = {
  disqusId: '',
  slug: '',
  weatherEnabled: false,
  isMultiLivecam: false,
};

export default connect(mapStateToProps)(LiveCam);
